import React, { useState } from 'react';
import BeadStateManager from './components/BeadStateManager'
import "react-simple-keyboard/build/css/index.css";
import "./App.css";

function App() {

  return (
    <div className="App">
        <BeadStateManager />
    </div>
  );
}

export default App;
